import React from "react"
import {Link} from "@reach/router"

const NavLink = ({...props}) => {
  return <Link {...props} />
}
export default NavLink
